import { hasDrawingName } from './drawingName.mjs';

// Signed thumbnail URLs stay in component memory and are never persisted.
export default {
    data() {
        return { s3Thumbnail: '', s3PreviewRequest: null, s3PreviewAttempted: '', s3PreviewDisposed: false };
    },
    computed: {
        s3PreviewKey() {
            if (!this.articolo || !hasDrawingName(this.disegno) || !/\.pdf$/i.test(this.disegno || '')) return '';
            return `${this.articolo[0]}/${this.articolo}/${this.disegno}`;
        },
    },
    watch: {
        s3PreviewKey: 'resetS3Preview',
        thumbnailSize: 'resetS3Preview',
    },
    methods: {
        resetS3Preview() {
            this.s3Thumbnail = '';
            this.s3PreviewAttempted = '';
            this.s3PreviewRequest = null;
            this.thumbnailUnavailable = false;
            this.setMissingState(false);
            clearTimeout(this.refreshtimer);
            if (this.s3First) this.loadS3Preview();
        },
        async loadS3Preview() {
            const key = this.s3PreviewKey;
            if (!key || this.s3PreviewDisposed) return false;
            if (this.s3Thumbnail) return true;
            if (this.s3PreviewRequest) return this.s3PreviewRequest;
            if (this.s3PreviewAttempted === key) return false;
            this.s3PreviewAttempted = key;
            const request = this.$work.post('files/disegni/thumbnail/', { key, inline: true, size: this.thumbnailSize }, true)
                .then(response => {
                    if (this.s3PreviewDisposed || key !== this.s3PreviewKey || this.s3PreviewRequest !== request) return false;
                    if (response?.status !== 200 || !response.data?.url) return false;
                    this.s3Thumbnail = response.data.url;
                    this.thumbnailUnavailable = false;
                    this.setMissingState(false);
                    clearTimeout(this.refreshtimer);
                    return true;
                })
                .catch(() => false);
            this.s3PreviewRequest = request;
            try {
                return await request;
            } finally {
                if (this.s3PreviewRequest === request) this.s3PreviewRequest = null;
            }
        },
    },
    beforeDestroy() {
        this.s3PreviewDisposed = true;
    },
};
